// Section 24.12: migrations are pure (envelope) -> envelope functions bumping formatVersion by
// one, applied in order on load. Append-only: add `NNNN-description.ts` and list it here; never
// edit a migration after merge. Each ships a fixture of the previous format and a test
// (tests/unit/persist-migrations.test.ts).
import { SimError } from '../../sim/api';
import { FORMAT_VERSION, type RawEnvelope } from '../envelope';
import { addSummary } from './0001-add-summary';
import type { Migration } from './types';

export type { Migration } from './types';

export const migrations: readonly Migration[] = [addSummary];

/** Apply every migration from the envelope's format up to FORMAT_VERSION. */
export function migrate(envelope: RawEnvelope): RawEnvelope {
  if (envelope.formatVersion > FORMAT_VERSION)
    throw new SimError(
      'migration',
      `save format ${envelope.formatVersion} is newer than this build (${FORMAT_VERSION})`,
    );
  let out = envelope;
  while (out.formatVersion < FORMAT_VERSION) {
    const from = out.formatVersion;
    const next = migrations.find((m) => m.from === from);
    if (next === undefined)
      throw new SimError('migration', `no migration from save format ${from}`);
    out = next.migrate(out);
    if (out.formatVersion !== next.to)
      throw new SimError('migration', `migration ${from} -> ${next.to} did not bump the format`);
  }
  return out;
}
